import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import  { store }  from './redux/store';
import { Provider } from 'react-redux';

import { LicenseInfo } from '@mui/x-license-pro';
LicenseInfo.setLicenseKey(
  '4c785f3decbd995d502e2004d6d4f9f6Tz01Mjg4NyxFPTE2OTc5MjY4MDQwMTAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <React.StrictMode>
        <BrowserRouter basename='/'>
          <App />
        </BrowserRouter>
    </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
